var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import history from 'store/history';
var CreateNewAccountViaSocialDialog = function (_a) {
    var loginActionFunc = _a.loginActionFunc, loginData = _a.loginData, social = _a.social, accountDataComponent = _a.accountDataComponent, handleClose = _a.handleClose;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var handleCreate = function () {
        dispatch(loginActionFunc(loginData));
    };
    var returnToLogin = function () {
        handleClose();
        history.push('/login');
    };
    return (_jsx("div", __assign({ className: "flex flex-col max-w-320 justify-center items-center" }, { children: _jsxs("div", __assign({ className: "flex flex-col items-center space-y-20" }, { children: [_jsxs("p", __assign({ className: "text-14  dark:text-white" }, { children: [t('Вы выполняете первый вход через'), " ", t(social)] }), void 0), _jsx("p", __assign({ className: "text-14 dark:text-white text-center" }, { children: t('Хотите создать аккаунт в Импульс со следующими данными?') }), void 0), accountDataComponent, _jsxs("div", __assign({ className: "flex flex-col w-full items-center space-y-20" }, { children: [_jsx(Button, __assign({ onClick: handleCreate }, { children: t('Создать аккаунт') }), void 0), _jsx(Button, __assign({ variant: "text", onClick: returnToLogin }, { children: t('Отмена') }), void 0)] }), void 0)] }), void 0) }), void 0));
};
export default CreateNewAccountViaSocialDialog;
